import { Lead } from "../model";

export const getEmptyLeads = (count: number) => {
   const leads = Array<Lead>();
   for (let i = 0; i < count; i++) {
      leads.push(new Lead());
   }
   return leads;
};
